import { MenuItem, TextField } from '@mui/material'
import React from 'react'
import { IdType } from 'shared/hooks/standards/hooks'

interface ItemSelectProps<T, V extends IdType> {
  items: T[]
  disabledItems?: number[]
  currentVal?: V
  onValChange: (val: V) => unknown
  itemDisplay: (item: T) => string
  itemValue: (item: T) => V
  label?: string
  fullWidth?: boolean
}

export function ItemSelect<T, V extends IdType = IdType>({
  items,
  disabledItems,
  currentVal,
  itemDisplay,
  itemValue,
  onValChange,
  label,
  fullWidth,
}: ItemSelectProps<T, V>) {
  return (
    <TextField
      select
      label={label}
      value={currentVal || ''}
      fullWidth={fullWidth}
      onChange={(e) => {
        const raw = e.target.value
        onValChange((raw === '' ? undefined : (raw as typeof currentVal)) as V)
      }}
      slotProps={{
        select: {
          autoFocus: true,
        },
      }}
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      {items.map((item, idx) => {
        const val = itemValue(item)
        return (
          <MenuItem
            disabled={disabledItems?.includes(idx)}
            key={String(val)}
            value={val}
          >
            {itemDisplay(item)}
          </MenuItem>
        )
      })}
    </TextField>
  )
}
